import { Card, Header, Spacer } from '@procurify/ui'
import { useSelector } from 'react-redux'

import {
  formatAccountCodeAttribute,
  formatSecondaryOrgCategoryAttribute,
  formatViewersAttribute,
} from '@webapp/components/Budgets/SpendTracker/utils'
import { makeSelectFeatureSwitches } from '@webapp/core/stores/global'
import { useProcurifyIntl } from '@webapp/hooks'
import { type AccountCode, type Department, type User } from '@webapp/models'
import messages from './messages'
import { BudgetCategoryAttributeDescriptions } from '../BudgetCategoryAttributeDescriptions'
import { BudgetCategoryAttributesCardStyled } from './styles/BudgetCategoryAttributesCardStyled'

export interface IBudgetCategoryAttributesCardProps {
  header?: string
  departments: Department[]
  accountCodes: AccountCode[]
  viewers: User[]
  isSourceOfTruth?: boolean
}

export const BudgetCategoryAttributesCard = ({
  header,
  departments,
  accountCodes,
  viewers,
  isSourceOfTruth,
}: IBudgetCategoryAttributesCardProps) => {
  const intl = useProcurifyIntl()
  const { enable_flexible_spend_tracking: isFlexibleSpendTrackingEnabled } =
    useSelector(makeSelectFeatureSwitches())

  const formatBudgetCategoryAttributes = (
    _departments,
    _accountCodes,
    _viewers
  ) => {
    return [
      {
        label: intl.formatMessage(messages.secondaryOrgCategoryLabel),
        value: formatSecondaryOrgCategoryAttribute(_departments),
      },
      {
        label: intl.formatMessage(messages.accountCodesLabel),
        value: formatAccountCodeAttribute(_accountCodes),
      },
      {
        label: intl.formatMessage(messages.viewersLabel),
        value: formatViewersAttribute(_viewers),
      },
    ]
  }

  return (
    <BudgetCategoryAttributesCardStyled>
      <Card>
        <Card.Content>
          <Header as='h5'>
            {header ||
              intl.formatMessage(
                isFlexibleSpendTrackingEnabled
                  ? messages.budgetAttributesCardHeader
                  : messages.oldBudgetCategoryAttributesCardHeader
              )}
          </Header>
          <Spacer space={1} />
          <BudgetCategoryAttributeDescriptions
            attributes={formatBudgetCategoryAttributes(
              departments,
              accountCodes,
              viewers
            )}
            isSourceOfTruth={isSourceOfTruth}
          />
        </Card.Content>
      </Card>
    </BudgetCategoryAttributesCardStyled>
  )
}

BudgetCategoryAttributesCard.displayName = 'BudgetCategoryAttributesCard'
